"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOperationsPageSize = void 0;
function getOperationsPageSize(accountId, syncConfig) {
    const { paginationConfig } = syncConfig;
    const { operationsPerAccountId, operations } = paginationConfig;
    const numbers = [];
    if (operationsPerAccountId && accountId && accountId in operationsPerAccountId) {
        numbers.push(operationsPerAccountId[accountId]);
    }
    if (typeof operations === "number") {
        numbers.push(operations);
    }
    if (numbers.length === 0)
        return Infinity;
    return Math.max(...numbers);
}
exports.getOperationsPageSize = getOperationsPageSize;
//# sourceMappingURL=pagination.js.map